<!-- < button
  mat-flat-button
  color="primary"
  type="button"
  class="app-standard-button"
  (click)="onClick($event)"
  [disabled]="isDisabled"
  [class.rules-disabled]="isDisabled"
>
  <span [ngStyle]="buttonWidth ? {width : buttonWidth} : null">{{ label }}</span>
</button> -->


<!-- TODO: Make this work. Works? -->

<ui-button
  *ngIf="!hideButton"
  (click)="onClick($event)"
  [disabled]="isDisabled"
  [buttonText]="label"
  [ariaLabel]="ariaLabel"
  [outlined]="params.outlined ?? false"
>
</ui-button>
